import { StuckOrdersTable } from "@/features/invoices/stuck-orders-table";

const StuckOrdersScreen = () => {
  return (
    <div className="p-4">
      <div className="mb-4">
        <h1 className="text-2xl font-bold">Stuck Orders</h1>
        <p className="text-sm text-muted-foreground mt-1">
          Orders that should be invoiced based on payment terms but haven&apos;t
          been processed yet.
        </p>
      </div>
      <StuckOrdersTable />
    </div>
  );
};

export default StuckOrdersScreen;
